import {Button, Grid} from "@mui/material";
import {makeStyles} from '@mui/styles';
import styles from 'assets/jss/ProfileStyle';
import editIcon from "assets/img/editProfile.svg";

const useStyles = makeStyles(styles);

const ProfileContainer = (props) => {
    const {editClick, title, activeEdit, hiddenIcon, fromDevice} = props;
    const classes = useStyles();
    const checkDisable = !!(activeEdit?.personal || activeEdit?.scanCenter);

    return (
        <Grid className={classes.profileContainer}>
            <div className={classes.centerContainer}>
                <span className={classes.profileHeader}>{title}</span>
                {!hiddenIcon && <Button onClick={editClick} className={classes.editProfile} disabled={checkDisable}>
                    <img src={editIcon} className={classes.editIcon} alt='' style={{opacity: checkDisable && '0.5'}}/>
                </Button>}
            </div>
            <div className={classes.lineProfile}/>
            <Grid sx={{margin: fromDevice ? '0px' : '24px 24px 0 24px'}}>
                {props.children}
            </Grid>
        </Grid>
    );
};
export default ProfileContainer;